(function () {
  const Core = window.RB.Core;
  const { buff } = window.RB.CardLib;

  window.RB.CardScripts = window.RB.CardScripts || {};
  Object.assign(window.RB.CardScripts, {
    "Gentlemen's Duel": {
      targets: [{ bind: "t", spec: { type: "unit", friendly: true }, prompt: "Give which friendly unit +3 Might?" }],
      play: [
        buff("$t", 3),
        { op: "choose", spec: { type: "unit", enemy: true }, bind: "e", prompt: "They fight which enemy unit?" },
        { op: "fight", a: "$t", b: "$e" },
      ],
    },

    "Yi, Honed": { entersReady: true },

    "Decisive Strike": {
      play: [{ op: "grant", spec: { type: "unit", friendly: true }, might: 2, dur: "turn" }],
    },

    "Might of Demacia - Starter": {
      triggers: [{
        on: "conquer", you: true,
        condSpec: { k: "evBfUnitsAtLeast", n: 4 },
        label: "draw 2",
        program: [{ op: "draw", n: 2 }],
      }],
    },

    "Garen, Rugged": {},
  });
})();
